import { ServerInventory } from '../server-inventory/server-inventory';
/**
 * Represents the state of a failover cluster node.
 */
export enum ClusterNodeState {
    Unknown = -1,
    Up = 0,
    Down = 1,
    Paused = 2,
    Joining = 3
}

/**
 * Represents the Drain Status of a failover cluster node.
 */
export enum ClusterNodeDrainStatus {
    Unknown = -1,
    NotInitiated = 0,
    InProgress = 1,
    Completed = 2,
    Failed = 3
}

export class ClusterNodeInventory extends ServerInventory {
    /**
     * Indicates the state if the server is a cluster node
     */
    public state: ClusterNodeState;

    /**
     * Indicates the drain status if the server is a cluster node
     */
    public drainStatus: ClusterNodeDrainStatus;

    /**
     * Indicates the dynamic weight if the server is a cluster node
     */
    public dynamicWeight: number;

    /**
     * Indicates the node weight if the server is a cluster node
     */
    public nodeWeight: number;

    /**
     * Indicates the fault domain if the server is a cluster node
     */
    public faultDomain: string;
}
